// Escapes characters with special meaning in a Postgres LIKE/ILIKE pattern
// (\, %, _) so user-typed search text is matched literally. Usernames are
// allowed to contain "_" (see the username regex in Profile.jsx), which is a
// wildcard meaning "any one character" — left unescaped, searching
// "@john_doe" would also match "johnXdoe". Design titles can contain "_" or
// "%" too, causing the same kind of over-matching.
export function escapeLikePattern(str) {
  if (!str) return "";
  return str.replace(/[\\%_]/g, match => `\\${match}`);
}
